import { components } from "@/api-schema";
import { Action, MergeEntityName } from "@/api-schema-enums";
import { Can, useAbility } from "@/casl-provider";
import { ModelGenerationTable } from "@/components/data-table/predefined/model-generation-table";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { getModelGenerationMergeLabel } from "@/components/merge/_helpers/model-merge-labels";
import { MergeDialog } from "@/components/merge/merge-dialog";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const DEFAULT_PAGE_SIZE = 100;
type ModelGeneration = components["schemas"]["ModelGeneration"];

export function ModelGenerationView() {
  const { t, i18n } = useTranslation(["common", "masterdata"]);
  const ability = useAbility();
  const canManage = ability.can(Action.Manage, "ModelGeneration");
  const canMerge = ability.can(Action.Merge, "ModelGeneration");
  const defaultRowActions = canManage
    ? undefined
    : {
        showEdit: false,
        showDelete: false,
      };
  const [mergingModelGeneration, setMergingModelGeneration] = useState<ModelGeneration | null>(null);

  return (
    <Can I="read" a="ModelGeneration">
      <CenteredLayout
        variant={CenteredLayoutVariant.Table}
        title={t("common:Models")}
        subTitle={t("common:SearchFilterAndManageEntriesDescription")}
      >
        <ModelGenerationTable
          body={{}}
          pageSize={DEFAULT_PAGE_SIZE}
          showCreateButton={canManage}
          defaultRowActions={defaultRowActions}
          onMerge={canMerge ? setMergingModelGeneration : undefined}
        />
      </CenteredLayout>

      {mergingModelGeneration && (
        <MergeDialog
          open={true}
          entity={MergeEntityName.ModelGeneration}
          source={{
            uuid: mergingModelGeneration.uuid,
            label: getModelGenerationMergeLabel(mergingModelGeneration, i18n.language),
          }}
          onClose={() => setMergingModelGeneration(null)}
        />
      )}
    </Can>
  );
}
